import {
    Component,
    OnInit,
    HostBinding,
    HostListener,
    OnDestroy
} from '@angular/core';

import { Subject, Observable } from 'rxjs';
import { tap, map, takeUntil } from 'rxjs/operators';

import { MenuService, IMenuServiceDot } from '../menu.service';

@Component({
    selector: 'app-menu-burger',
    templateUrl: './menu-burger.component.pug',
    styleUrls: ['./menu-burger.component.less'],
    providers: []
})
export class MenuBurgerComponent implements OnInit, OnDestroy {
    _destroySbj: Subject<void> = new Subject();

    @HostBinding('class.--ui') _ui = true;
    @HostBinding('class.--active') isActive = false;

    @HostListener('click', ['$event'])
    onClick($event) {
        if (this.isActive) {
            $event.preventDefault();
            $event.stopPropagation();
        }
    }

    dotted$: Observable<boolean> = this._menuSrv.dot$.pipe(map((dots) => {
        return Object.values(dots).some((dot) => dot);
    }));

    constructor(
        private _menuSrv: MenuService
    ) {
        this._menuSrv.visible$
            .pipe(takeUntil(this._destroySbj))
            .pipe(tap((isVisible) => this.isActive = isVisible))
            .subscribe();
    }

    async ngOnInit() {
    }

    ngOnDestroy() {
        this._destroySbj.next();
        this._destroySbj.complete();
    }
}
